import PropTypes from 'prop-types';

const FavoriteType = {
    id: PropTypes.number,
    description: PropTypes.string
};

export { FavoriteType };
